import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import PopUpOther from './_PopUpOther';
import DataConfig from './../_config.json';

import './stylemain.css'
import { OnGetJsoni } from '../_getjson';
import { AlertPopup } from './../PopUp/AlertPopup';
const jobTypes = ['เปิด', 'ปิด'];

export default class _tab_2 extends React.Component {
    state = {
        // data1 : "",
        tableData: [],
        tableDatasede: [],
        countunitStock: "",
        rowChk: "",
        unitStockintable: "",
        colChk: "",
        rowtb: "15",
    }
    _spritData(data) {
        var str = data.split("|");
        return str;
    }

    setRow = (count) => {
        var data = [];
        for (var i = 0; i <= count - 1; i++) {
            data[i] = {
                C0: i + 1,
                C1: "",
                C1_insert: "",
                C3: "",
                C4: "",
            }
        }
        this.setState({ tableData: data });
        //  console.log(this.state.tableData);
    }
    componentDidMount() {
        this.setRow(this.state.rowtb);
        // setTimeout(() => {this.props.Getdata("dataunit",this.state);}, 50); 
    }
    //**************************************************************************popup**************************************************************************************/
    SetPopup = (data) => {
        this.setState({ PopUpTYpe: data });
        this.setState({ showPopupOT: !this.state.showPopupOT });
        //  console.log(data); 
    }
    Get_PopUpOther = (data) => {
        switch (this.state.PopUpTYpe) {
            case "unitStock":
                this.refs.countunitStock.value = this._spritData(data)[0] + ".";
                this.setState({ countunitStock: this._spritData(data)[0] });
                break;

            case "unitStockintable":
                // console.log(data);
                this.setState({ unitStockintabletoDB: this._spritData(data)[0] });
                this.setState({ unitStockintable: this._spritData(data)[1] });
                if (this.state.colChk === "1" && this.state.rowChk === "1") {
                    this.refs.countunitStock.value = this._spritData(data)[0] + ".";
                    this.setState({ countunitStock: this._spritData(data)[0] });
                }
                var dataArray = this.state.tableData;
                dataArray[this.state.rowChk - 1].TypeBtn = 1;
                let arrData = this.state.tableData;
                var j = this.state.rowintable;
                for (var i = this.state.tableData.length - 1; i >= 0; i--) {// หาจากล่างขึ้นบน
                    if (!this.state.tableData[i].C1) {
                        j = i;
                    }
                    else if (dataArray.C0 === this.state.tableData[i].C1) {
                        j = i;
                    }
                }//หา แถวที่ว่างบนสุดใน products Table

                arrData[j].C1_insert = this._spritData(data)[0];
                arrData[j].C1 = this._spritData(data)[0] + ".";
                arrData[this.state.rowChk - 1].TypeBtn = 2;
                this.setState({ tableData: arrData });
                break;
        }
        this.setState({ showPopupOT: !this.state.showPopupOT });
        setTimeout(() => { this.props.Getdata("dataunit", this.state); }, 50);
    }
    PopUpOtherClose = (data) => {
        this.setState({ showPopupOT: !this.state.showPopupOT });
    }
    _cellButton(cell, row, enumObject, rowIndex) {
        var btn = this.state.tableData[rowIndex].TypeBtn;
        var btnShow = "";
        switch (btn) {
            case 1: btnShow = <i class="fas fa-sort-down icon_down" onClick={this.SetPopup.bind(null, "unitStockintable")}></i>; break;
            default: btnShow = <i class=""></i>; break;
        }
        return (<div>{btnShow}</div>);
    }

    onRowClick = (row, col) => {
        if (col === 1) {
            this.setState({ rowChk: row['C0'] });

            setTimeout(() => {
                if (this.state.rowChk === "1") {
                    this.setState({ colChk: col });
                }
                var dataArray = this.state.tableData;
                let tableRow = dataArray.length;
                let i;
                for (i = 0; i <= tableRow; i++) {
                    try {
                        dataArray[i].TypeBtn = 2;
                    } catch (error) {
                        console.log(error);
                    }
                }
                dataArray[this.state.rowChk - 1].TypeBtn = 1;

                this.setState({ tableData: dataArray });
            }, 30);
        } else if (col === 3) {
            this.setState({ rowChk: row['C0'] });
            setTimeout(() => {
                var dataArray = this.state.tableData;
                try {
                    dataArray[this.state.rowChk - 1].TypeBtn = 2;
                }
                catch (err) {
                    console.log(err);
                }
                dataArray[this.state.rowChk - 1].C4 = "เปิด";
                this.setState({ tableData: dataArray });
            }, 30);
        } else {
            this.setState({ rowChk: row['C0'] });
            setTimeout(() => {
                var dataArray = this.state.tableData;
                try {
                    dataArray[this.state.rowChk - 1].TypeBtn = 2;
                }
                catch (err) {
                    console.log(err);
                }
                this.setState({ tableData: dataArray });
            }, 30);
        }
        setTimeout(() => { this.props.Getdata("dataunit", this.state); }, 80);
    }

    //------------------------------เช็คหลังกรอก-------------------------------------------------------------
    afterSaveCell = (row, cellName, cellValue) => {
        // do your stuff...  
        if (cellValue.length > 0 && cellName === 'C1') {
            this._addData(cellValue, row, cellName);
        }

        if (cellValue === "") {
            let dataArray = this.state.tableData;
            dataArray[this.state.rowChk - 1].C4 = "";
            dataArray[this.state.rowChk - 1].C3 = "";
            dataArray[this.state.rowChk - 1].C1_insert = "";
            this.setState({
                tableData: dataArray
            });

            setTimeout(() => {
                this._chkrowData(row, cellName, cellValue);
            }, 100);
        }
        setTimeout(() => { this.props.Getdata("dataunit", this.state); }, 50);
        localStorage.setItem("tableunit", JSON.stringify(this.state.tableData));
    }
    _chkrowData = (row, cellName, cellValue) => {
        if (cellName === "C1") {
            let data_2 = this.state.tableData;

            // setTimeout(() => { 
            if (row.C0 === 1) {
                this.refs.countunitStock.value = data_2[row.C0].C1;
                this.setState({
                    countunitStock: data_2[row.C0].C1_insert
                });
            }
            // }, 30);
            for (let index = row.C0; index <= data_2.length; index++) {
                try {
                    if (data_2[index].C1 !== "") {
                        data_2[index - 1].C1 = data_2[index].C1;
                        data_2[index - 1].C2 = data_2[index].C2;
                        data_2[index - 1].C3 = data_2[index].C3;
                        data_2[index - 1].C4 = data_2[index].C4;
                        data_2[index - 1].C1_insert = data_2[index].C1_insert;

                        data_2[index].C1 = "";
                        data_2[index].C2 = "";
                        data_2[index].C3 = "";
                        data_2[index].C4 = "";
                        data_2[index].C1_insert = "";
                    }
                } catch (error) {
                    console.log("err=>" + error);

                }
            }
            this.setState({
                tableData: data_2
            });



        }
    }
    _addData = (ItemCode, row, cellName) => {
        switch (cellName) {
            case "C1":
                var url = "CSUNIT/ByCode?code=" + ItemCode;
                let col = this.state.tableData;
                OnGetJsoni(url, "load").then(data => {
                    // console.log(data);
                    var j = this.state.rowintable;
                    for (var i = this.state.tableData.length - 1; i >= 0; i--) {// หาจากล่างขึ้นบน
                        if (!this.state.tableData[i].C1) {
                            j = i;
                        }
                        else if (ItemCode === this.state.tableData[i].C1) {
                            j = i;
                        }
                    }//หา แถวที่ว่างบนสุดใน products Table
                    if (data.length > 0) {
                        col[row.C0 - 1].C1 = "";
                        for (var i = 0; i < data.length; i++) { //เพิ่มขอมูลทั้งหมด ลง products Table 
                            // this.setState({wherehosesearch:})
                            if (col[j].C0 === 1) {
                                this.setState({
                                    countunitStock: data[i].CODE
                                });
                                this.refs.countunitStock.value = data[i].MYNAMETH;
                            }
                            col[j] = {
                                C0: this.state.tableData[j].C0,
                                C1: data[i].MYNAMETH + ".",
                                C1_insert: data[i].CODE,
                            }
                            j++;
                        }
                    } else {
                        col[row.C0 - 1].C1 = "";
                        col[row.C0 - 1].C3 = "";
                        col[row.C0 - 1].C4 = "";
                        AlertPopup("Warning", "ไม่พบข้อมุล!");
                        // setTimeout(() => {
                        //     this._chkrowData(row,cellName,ItemCode)
                        // }, 20);

                    }
                    this.setState({ tableData: col });
                });
                break;
        }
    }


    render() {
        const cellEditProp = {
            mode: 'click',
            afterSaveCell: this.afterSaveCell,
            blurToSave: true,
        };
        const options = {
            onRowClick: this.onRowClick,
        };
        return (
            <div class={this.props.Inventory.showResults === 1 ? '' : "InventoryHidden"}>
                {this.state.showPopupOT ? <PopUpOther closePopup={this.PopUpOtherClose} Get_PopUpOther={this.Get_PopUpOther} type={this.state.PopUpTYpe} Data={this.state.valuePopup} groupdata={this.state.grouptoDB} apikeyData={DataConfig.API_KEY[localStorage.getItem("company")]} jwtData={localStorage.getItem("Token")} /> : null}
                <br>
                </br>
                <div class="container-fluid">
                    <BootstrapTable
                        data={this.state.tableData}
                        cellEdit={cellEditProp}
                        options={options}
                        height="300"
                        headerStyle={{ borderBottom: '#BFBCBB  1px solid' }}
                    >
                        <TableHeaderColumn row='0' rowSpan='2' dataField='C0' width='50' isKey dataAlign='center' ></TableHeaderColumn>

                        <TableHeaderColumn row='0' colSpan='2' headerAlign='center' width='20%' className='colbuttomhidden' >หน่วยนับ</TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='C1' editable width="20%" dataAlign="center" >  </TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='Btn' editable={false} dataAlign="center" width="40" dataFormat={this._cellButton.bind(this)} columnClassName='c_btn'></TableHeaderColumn>
                        <TableHeaderColumn dataField='C1_insert' editable width="20%" dataAlign="center" hidden >  </TableHeaderColumn>

                        <TableHeaderColumn row='0' rowSpan='2' dataField='C3' editable width="35%" dataAlign="center"> อัตรา </TableHeaderColumn>
                        <TableHeaderColumn row='0' rowSpan='2' dataField='C4' width="35%" dataAlign="center" editable={{ type: 'select', options: { values: jobTypes } }}> การใช้งาน </TableHeaderColumn>
                    </BootstrapTable>
                    <br>
                    </br>
                    <div class="form-group unitDrop">
                        <div class="input-group ">
                            <span class="input-group-addon"> หน่วยนับสต๊อก : </span>
                            <input id="unitStock" name="unitStock" type="text" class="form-control readonly" ref="countunitStock" />
                            <span class="input-group-addon textIcon" onClick={this.SetPopup.bind(null, "unitStock")}>
                                <i class="fas fa-sort-down icon_down"></i>
                            </span>
                        </div>
                    </div>
                    <p id="load" ></p>
                </div>
            </div>
        )
    }
}